/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useEffect, useState } from "react";
import * as API from "../../http/api";
import { closelightbox } from "../../util/Functions";
import { useHistory } from "react-router-dom";
import { Grid, TextField, Button, DialogActions, DialogContent, Dialog, DialogTitle, IconButton } from "@mui/material";
import { ModalStyle } from "../../util/Styles";
import { Close } from "@mui/icons-material";

const AssignRif = (props) => {
  const history = useHistory();
	const [zPos, setZPos] = useState(45)
  const [name, setName] = useState("");
  const [disabled, setDisabled] = useState(true);
  const [uuid, setUuid] = useState("");
  const [accountName, setAccountName] = useState("");
  const [accountDesc, setAccountDesc] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  useEffect(() => {
    init();
  }, []);

  const init = async () => {
    setName(props.contentModal.customer.name);
    setUuid(props.contentModal.customer.uuid);
  };

  const change = (name, e) => {
    let aN = accountName;
    let aD = accountDesc;
    let aNum = accountNumber;
    if (name == "name") {
      aN = e.target.value;
    }
    if (name == "desc") {
      aD = e.target.value;
    }
    if(name == "number"){
      aNum = e.target.value;
    }
    if (aN && aD && aNum) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
    setAccountName(aN);
    setAccountDesc(aD);
    setAccountNumber(aNum);
  };

  const createAccount = async () => {
    props.changeLoader(true);
		setZPos(-1)
    let data = {
      space: {
        owner: {
          application_uuid: "4",
          entity_uuid: uuid,
        },
        general: {
          account_number: accountNumber,
          name: accountName,
          description: accountDesc,
        },
        customer: {
          name: name,
        },
        type: "1",
        profile: "key-debit-n7",
      },
    };

    let createSpaceRiff = await API.service( "spaceRif", data, props.pos, props.changeAlert, props.changeLoader, history );
    if (createSpaceRiff.status == 200) {
			if (createSpaceRiff.data.data.response == "OK") {
				props.changeAlert(true, "ok", "Solicitud de asociación recibida. Revisa si el cliente se refleja en tu listado de empresas, de lo contrario reintenta.");
				closelightbox();
			}
		}
		props.changeLoader(false);
		setZPos(45)
  };

  return (
		<Dialog open={true} sx={{zIndex: zPos, filter: zPos !== 45 ? 'blur(2px)': "none" }} fullWidth>
      <ModalStyle property={String(disabled)}>
        <DialogTitle>
					Asociar RIF a: <p id="subtitle">{name}</p>
          <IconButton id="headButton" onClick={closelightbox}><Close/></IconButton>
        </DialogTitle>
        
        <DialogContent>
          <Grid container spacing={2} sx={{ marginTop: "10px" }}>
            <Grid item xs={6}>
              <TextField label="Nombre" value={accountName} onChange={change.bind(this, "name")} size="small" fullWidth />
            </Grid>
            <Grid item xs={6}>
              <TextField label="Descripción" value={accountDesc} onChange={change.bind(this, "desc")} size="small" fullWidth />
            </Grid>            
          </Grid>
          <Grid container spacing={2} sx={{ marginTop: "10px" }}>
            <Grid item xs={6}>
              <TextField label="Número de cuenta" value={accountNumber} onChange={change.bind(this, "number")} size="small" fullWidth />
            </Grid>
                        
          </Grid>
        </DialogContent>

        <DialogActions>       
          <Button disabled={disabled} variant="contained" onClick={createAccount.bind(this)} >Guardar</Button>
        </DialogActions>
      </ModalStyle>
    </Dialog>   
  );
};

export default AssignRif;
